export const allChildren = (el) => {
  return document.querySelectorAll(el)
}

export const firstChild = (el) => {
  return document.querySelectorAll(el)[0]
}

export const getElementsByClass = (className) => {
  return Array.from(document.getElementsByClassName(className))
}

export const getChildByClassFromParent = (parentElem, className) => {
  return Array.from(parentElem.getElementsByClassName(className))[0]
}

export const toggleElementClass = (elem, ...classes) => {
  for (const item of classes) {
    elem.classList.toggle(item)
  }
}

export const debounce = (func, delay) => {
  let timeout

  return function executedFunction(...args) {
    const later = () => {
      clearTimeout(timeout)
      func(...args)
    }

    clearTimeout(timeout)
    timeout = setTimeout(later, delay)
  }
}

export const throttle = (func, delay) => {
  let wait = false

  return (...args) => {
    if (wait) {
      return
    }

    func(...args)
    wait = true
    setTimeout(() => {
      wait = false
    }, delay)
  }
}

export const handleize = (str) => {
  const normalizedStr = str.normalize('NFD').replace(/[\u0300-\u036f]/g, '');

  return normalizedStr
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/-$/, '')
    .replace(/^-/, '')
}

export function findSubstrings(arr, target) {
  let result = []

  for (let i = 0; i < arr.length; i++) {
    if (target.includes(arr[i])) {
      result.push(arr[i])
    }
  }

  return result
}
